// The Save PATCH builder for the customer popup, kept standalone so it can be
// unit-tested without mounting the whole popup (and its apiClient/router deps).
//
// THE RULE (defect D-036): a Save sends ONLY the fields the user changed, diffed
// against the loaded record. It never snapshots the record, and never sweeps
// unknown keys into extended_fields — that 56-key dump is exactly the bug.

// The editable customer fields. Anything NOT here is never written.
export const CUSTOMER_EDITABLE = [
  "first_name", "last_name", "full_name", "company_name", "is_business",
  "primary_phone", "secondary_phone", "primary_email", "secondary_email",
  "address", "city", "state", "zip_code", "county", "country", "industry",
  "access_notes", "notes",
  // Overview left column (Design Standard v1 customer window)
  "preferred_channel", "lead_source", "property_type", "gate_code",
  "has_pets", "seasonal_resident",
];

const norm = (v) => (v === undefined || v === null ? "" : typeof v === "boolean" ? v : String(v));

export function buildCustomerPatch(formData = {}, original = {}) {
  const patch = {};
  CUSTOMER_EDITABLE.forEach((key) => {
    if (!(key in formData)) return;
    if (norm(formData[key]) !== norm(original[key])) patch[key] = formData[key];
  });
  // extended_fields (e.g. follow_up) is a known object — included only when the
  // user's version differs, merged onto the original so untouched keys survive.
  if ("extended_fields" in formData) {
    const a = formData.extended_fields && typeof formData.extended_fields === "object" ? formData.extended_fields : null;
    const b = original.extended_fields && typeof original.extended_fields === "object" ? original.extended_fields : null;
    if (JSON.stringify(a) !== JSON.stringify(b)) patch.extended_fields = { ...(b || {}), ...(a || {}) };
  }
  return patch;
}
